import { Controller,Post,Body, HttpException, HttpStatus, Req } from '@nestjs/common';
import {AuthService} from './auth.service';
import {CreateUserDto,LoginUserDto, updateUserDto, UpdateUserDto} from '../user/dto/user.dto'
import {RegistrationStatus} from '../user/dto/registraton.dto';
import { ApiTags } from '@nestjs/swagger';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { ProjectsResponseModel, UserStatusWiseResponseModel } from '@gtpl/shared-models/gtpl';
import { request } from 'https';

@ApiTags('Auth')
@Controller('auth')
export class AuthController {
  constructor(private readonly authService:AuthService) {}
  @Post('register')  
  public async register(@Body() createUserDto: CreateUserDto, @Req() request:Request): Promise<RegistrationStatus> {    
    const result: 
    RegistrationStatus = await this.authService.register(createUserDto,request);
    if (!result.success) {
        throw new HttpException(result.message, HttpStatus.BAD_REQUEST);    
    }
    console.log(result);
    return result;  
  }
  // @Post('updateUser')  
  // public async updateUser(@Body() updateUserDto: updateUserDto,  ): Promise<RegistrationStatus> {    
  //   const result: 
  //   RegistrationStatus = await this.authService.updateUser(updateUserDto,);
  //   if (!result.success) {
  //       throw new HttpException(result.message, HttpStatus.BAD_REQUEST);    
  //   }
  //   console.log(result);
  //   return result;  
  // }
  @Post('login')  
  public async login(@Body() loginUserDto: LoginUserDto): Promise<any> {
    // console.log(loginUserDto);
    try{
      return await this.authService.login(loginUserDto); 
    } catch(error) {
      // return errorHandler(ProjectsResponseModel, error);
      throw new ProjectsResponseModel(false,11104, 'Something wrong');
    }
  }
  @Post('getAllUsers')  
  public async getAllUsers(): Promise<LoginUserDto> {
    // console.log(loginUserDto);
      return await this.authService.getAllUsers();  
  }

  @Post('updateUser')  
  public async updateUser(@Body() createUserDto: updateUserDto, @Req() request:Request ): Promise<RegistrationStatus> {  
    const result: 
    RegistrationStatus = await this.authService.updateUser(createUserDto,request);
    if (!result.success) {
        throw 'new HttpException(result.message, HttpStatus.BAD_REQUEST)';    
    }
    return result;
  }  
  @Post('getActiveUsersCount')  
  public async getActiveUsersCount(): Promise<UserStatusWiseResponseModel> {
    // console.log(loginUserDto);
      return await this.authService.getActiveUsersCount();  
  }
}
